import script from "./AdBlockDetectedModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AdBlockDetectedModal.vue?vue&type=script&setup=true&lang=js"

import "./AdBlockDetectedModal.vue?vue&type=style&index=0&id=47968927&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47968927"]])

export default __exports__